export default __webpack_public_path__ + "static/media/img_scsc_16.bd395698.png";